import { BASE_URL } from "../utils/config";
const apiUrl = BASE_URL + "/tkapi";

export const loginReducerApi = {
    login: apiUrl + "/v1/distributor/login",
    generateToken: apiUrl + "/v6/tkapi/generateTokenWeb",
    refreshToken: apiUrl + "/v1/distributor/refreshToken",
};
export const forgotPwdReducerApi={
    forgotPassword: apiUrl+"/v1/distributor/forgotPwd"
}
export const distributorDetailsApi={
    getDistributorDetails:apiUrl+"/v1/distributor/profile/getDistributerDetails",
    updateDistributerDetails: apiUrl+"/v1/distributor/profile/updateDistributerDetails",
    updateDistributerPassword: apiUrl+"/v1/distributor/profile/updatePassword",
}
export const getCountriesApi={
    getCountries:apiUrl+"/v1/distributor/getCountries"
}
export const getMoviesListApi={
    getMovies:apiUrl+"/v1/distributor/movies"
}
export const watchedHoursMetricsApi={
    watchedHoursMetrics : apiUrl+"/v1/distributor/getWatchedHoursMetrics"
}
export const topContentViewsApi={
    topContentViews: apiUrl+"/v1/distributor/topContentByViews"
}
export const watchedHoursGridApi={
    watchedHoursGrid:apiUrl+"/v1/distributor/getMoviesWatchedHours"
}